import React from "react";
import BreadCrumb from "../../Common/BreadCrumb";

const Validation = () => {
  return (
    <React.Fragment>
      <BreadCrumb title="Validation" pageType="Forms" />
      <div className="flex flex-col gap-4 min-h-[calc(100vh-212px)]">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div className="p-5 bg-white border rounded border-black/10 dark:bg-darklight dark:border-darkborder">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Validation Wrong
            </h2>
            <form className="space-y-4">
              <div>
                <input
                  type="text"
                  placeholder="First Name"
                  className="form-input text-danger !border-danger placeholder:text-danger"
                  required
                />
                <p className="mt-1 text-danger">Please fill the Name</p>
              </div>
              <div>
                <input
                  type="email"
                  placeholder="Email Type"
                  className="form-input"
                  required
                />
              </div>
              <div>
                <input
                  type="password"
                  placeholder="Password"
                  className="form-input"
                  required
                />
              </div>
              <div>
                <input
                  type="password"
                  placeholder="Confirm Password"
                  className="form-input"
                  required
                />
              </div>
              <div>
                <input
                  type="submit"
                  className="btn bg-purple border border-purple rounded-md text-white transition-all duration-300 hover:bg-purple/[0.85] hover:border-purple/[0.85]"
                  value="Submit"
                />
              </div>
            </form>
          </div>
          <div className="p-5 bg-white border rounded border-black/10 dark:bg-darklight dark:border-darkborder">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Validation Complate
            </h2>
            <form className="space-y-4">
              <div>
                <input
                  type="text"
                  placeholder="First Name"
                  className="form-input text-success !border-success placeholder:text-success"
                  required
                />
                <p className="mt-1 text-success">Please fill the Name</p>
              </div>
              <div>
                <input
                  type="email"
                  placeholder="Email Type"
                  className="form-input"
                  required
                />
              </div>
              <div>
                <input
                  type="password"
                  placeholder="Password"
                  className="form-input"
                  required
                />
              </div>
              <div>
                <input
                  type="password"
                  placeholder="Confirm Password"
                  className="form-input"
                  required
                />
              </div>
              <div>
                <input
                  type="submit"
                  className="btn bg-purple border border-purple rounded-md text-white transition-all duration-300 hover:bg-purple/[0.85] hover:border-purple/[0.85]"
                  value="Submit"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Validation;